module.exports = __webpack_public_path__ + "img/build-drain-grating-2.42c0b425.jpg";